import React, { useState, useEffect } from "react";
import { Form } from "antd";
import Draggable from "react-draggable";
import { CloseOutlined } from "@ant-design/icons";
import { Modal, Button, Typography, Row } from "antd";
import { BranchSelect } from "../../components/forms/AutoCompleteFormItem";
import CheckBoxItem from "../../components/forms/CheckBoxItem";
import { DatePickerItem } from "../../components/forms/FormItems";
import AnimationChildWrapper from "../../components/animations/AnimationChildWrapper";
import ChildrenAnimationWrapper from "../../components/animations/ChildrenAnimationWrapper";
import moment from "moment";

const { Title } = Typography;
const MonthAndBranchesModal = (props) => {
  const {
    onHide,
    visible,
    title,
    btnText,
    initialValues,
    onSubmit,
    branchId,
    loading,
    single,
    onChange,
    additionaItems,
    requiredItems,
    hideMonth,
  } = props;
  const [disabled, setDisabled] = useState(true);
  const [values, setValues] = useState(true);
  const [form] = Form.useForm();

  useEffect(() => {
    setValues(initialValues);
    form.setFieldsValue(initialValues);
    return function cleanup() {
      form.resetFields();
    };
  }, [visible]);

  const onCancel = () => {
    onHide();
    form.resetFields();
  };

  const onMouseOver = () => {
    setDisabled(false);
  };

  const onMouseOut = () => {
    setDisabled(true);
  };

  const onValuesChange = (changedValues, allValues) => {
    setValues(allValues);
    if (changedValues["all_branches"]) {
      form.setFieldsValue({ ...allValues, branches: [] });
    }
    if (onChange) {
      onChange(form, changedValues, allValues);
    }
  };

  const onFinish = (values) => {
    onSubmit({ ...values, month: moment(values.month).format() });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const layout = {
    labelCol: { span: 9 },
    wrapperCol: { span: 15 },
  };
  let requiredNotFilled = false;
  if (requiredItems && requiredItems.length > 0) {
    requiredItems.forEach((item) => {
      const value = form.getFieldValue(item);
      if (!value) {
        requiredNotFilled = true;
      }
    });
  }

  const isFormValid = () => {
    const hasMonth = hideMonth ? true : !!values.month;
    const hasBranches = values.branches && values.branches.length > 0;
    const hasAllBranches = !!values.all_branches;
    const hasSingleBranch = single && !!values.branches;
    const hasBranchId = !!branchId;

    return (
      hasMonth &&
      (hasBranches || hasAllBranches || hasSingleBranch || hasBranchId)
    );
  };

  const isSubmitDisabled = requiredNotFilled || !isFormValid();

  return (
    <Modal
      closable={false}
      footer={null}
      maskClosable={false}
      title={null}
      width={"600px"}
      styles={{
        body: {
          padding: 0,
        },
      }}
      open={visible}
      modalRender={(modal) => (
        <Draggable disabled={disabled}>{modal}</Draggable>
      )}
      forceRender
    >
      <div>
        <div
          style={{
            width: "100%",
            cursor: "move",
            height: "50px",
            position: "absolute",
            left: "0",
            top: "0",
          }}
          className="header"
          onMouseOver={onMouseOver}
          onMouseOut={onMouseOut}
        >
          <Button
            style={{ position: "absolute", left: 10, top: 10 }}
            className="closeBtn"
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={onCancel}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "40px 40px 40px 40px",
          }}
        >
          <Title
            style={{
              fontSize: "30px",
              fontWeight: 500,
              lineHeight: 1.27,
              color: "rgba(0, 0, 0, 0.85)",
              margin: "13px 0 40px 0 ",
              textAlign: "center",
            }}
          >
            {title}
          </Title>
          <div
            style={{ display: "flex", flexDirection: "column", width: "300px" }}
          >
            <Form
              {...layout}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              form={form}
              onValuesChange={onValuesChange}
            >
              <ChildrenAnimationWrapper>
                <Row>
                  <div style={{ flex: 1 }}>
                    {!hideMonth && (
                      <AnimationChildWrapper itemKey={1}>
                        <DatePickerItem
                          name="month"
                          category="component"
                          picker="month"
                          format={"MM/YYYY"}
                          required={true}
                        />
                      </AnimationChildWrapper>
                    )}

                    {!branchId && !values.all_branches && (
                      <AnimationChildWrapper itemKey={2}>
                        <BranchSelect
                          name="branches"
                          category="component"
                          required={!values.all_branches}
                          mode={single ? "" : "multiple"}
                          disabled={values.all_branches}
                        />
                      </AnimationChildWrapper>
                    )}
                    {!branchId && !single && (
                      <AnimationChildWrapper itemKey={3}>
                        <CheckBoxItem
                          showLabel={true}
                          name="all_branches"
                          category="component"
                        />
                      </AnimationChildWrapper>
                    )}
                    {additionaItems}
                    <AnimationChildWrapper itemKey={4}>
                      <div
                        style={{
                          alignItems: "center",
                          justifyContent: "center",
                          display: "flex",
                        }}
                      >
                        <Button
                          htmlType="submit"
                          style={{ marginTop: "20px" }}
                          type="primary"
                          disabled={isSubmitDisabled}
                          loading={loading}
                        >
                          {btnText}
                        </Button>
                      </div>
                    </AnimationChildWrapper>
                  </div>
                </Row>
              </ChildrenAnimationWrapper>
            </Form>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MonthAndBranchesModal;
